<template>
  <div class="pc-line">
    <div class="line-head flex-between">
      <div class="tab-group flex-between">
        <span>{{ title }}</span>
        <!-- <div
          class="k-btn"
          :class="{ active: active === 0 }"
          @click="changeLine(0)"
        >
          {{ $t("home.burnQuotes") }}
        </div>
        <div
          class="k-btn"
          :class="{ active: active === 1 }"
          @click="changeLine(1)"
        >
          {{ $t("home.priceQuotes") }}
        </div> -->
      </div>
    </div>
    <div class="line-body">
      <div class="tab-group">
        <span :class="{ active: lineActive === 0 }" @click="changeLineRange(0)"
          >D1</span
        >
        <span :class="{ active: lineActive === 1 }" @click="changeLineRange(1)"
          >W1</span
        >
        <span :class="{ active: lineActive === 2 }" @click="changeLineRange(2)"
          >M1</span
        >
      </div>
      <div id="coinLine"></div>
    </div>
  </div>
</template>
<script>
import klineBase from "@/mixins/Home/kline.js";
export default {
  mixins: [klineBase],
};
</script>


<style lang="scss" scoped>
.pc-line {
  width: 525px;
  height: 100%;
  padding: 15px 15px 5px 15px;
  background: $white;
  .line-head {
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: $font_grey;
    }
    .tab-group {
      // width: 146px;
      .k-btn {
        margin-left: 10px;
        padding: 0 10px;
        width: fit-content;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: rgba(217, 217, 217, 1);
        border-radius: 9px;
        color: #343640;
        cursor: pointer;
        transition: 0.3s;
      }
      .active {
        background: $blue;
        color: $white;
      }
    }
  }
  .line-body {
    margin-top: 10px;
    .tab-group {
      text-align: right;
      span {
        margin-right: 31px;
        color: $font_grey;
        cursor: pointer;
      }
      .active {
        color: $blue;
      }
    }
    #coinLine {
      margin-top: 5px;
      height: 115px;
    }
  }
}
</style>